import React, { useEffect } from 'react'
import { useDispatch } from 'react-redux'
import { Formik } from 'formik'
import * as Yup from 'yup'
import { FieldError } from '../../cdui'
import { startLogin } from '../../redux/actions/auth'
import { useToggle } from '../../hooks'
import { history } from '../../routers/AppRouter'

const initialValues = {
  email: '',
  password: ''
}

const FormSchema = Yup.object().shape({
  email: Yup.string().trim().email('Please provide a valid email').required('This field is required'),
  password: Yup.string().required('This field is required')
    .matches(/^(?=.*[0-9])(?=.*[A-Z])(?=.*[a-z]).{6,}$/, {
      message: 'Please enter a valid password.',
      excludeEmptyString: false
    })
})

const LoginPage = (props) => {
  const dispatch = useDispatch()
  const [passwordReveal, togglePassword] = useToggle()

  const renderForm = ({ handleChange, handleBlur, handleSubmit, isSubmitting, errors, values, touched }) => {
    return (
      <form onSubmit={handleSubmit} noValidate autoComplete='off'>
        <div className={errors.email && touched.email ? 'form-group has-danger' : 'form-group'}>
          <label htmlFor='email'>Email</label>
          <input
            className={errors.email ? 'form-control form-control-danger' : 'form-control'}
            type='email'
            name='email'
            onChange={handleChange}
            onBlur={handleBlur}
            value={values.email} />
          <FieldError error={errors.email} touched={touched.email} />
        </div>

        <div className={errors.password && touched.password ? 'form-group form-relative has-danger mb-1' : 'form-group form-relative mb-1'}>
          <label htmlFor='password'>Password</label>
          <input
            className={errors.password ? 'form-control form-control-danger' : 'form-control'}
            type={passwordReveal ? 'text' : 'password'}
            name='password'
            onChange={handleChange}
            onBlur={handleBlur}
            value={values.password} />
          <span className={`fas fa-${passwordReveal ? 'eye' : 'eye-slash'} pointer icon-end`} onClick={togglePassword} />
        </div>
        <FieldError error={errors.password} touched={touched.password} />

        <button className='btn btn-primary btn-block my-3' type='submit' disabled={isSubmitting}>Log In</button>
        <button className='btn btn-link btn-block mb-3' type='submit' disabled={isSubmitting} onClick={() => { history.push('/forgot-password') }}>Forgot Password?</button>
      </form>
    )
  }

  return (
    <div className='row align-items-center justify-content-center m-0'>
      <div className='col-12 col-lg-4 py-5'>
        <div className='py-3 py-lg-5 px-3'>
          <h2 className='mb-3 text-center py-3'>Log In</h2>

          <Formik
            initialValues={initialValues}
            validationSchema={FormSchema}
            onSubmit={(values, actions) => {
              dispatch(startLogin(values, actions.setSubmitting))
            }}>
            {renderForm}
          </Formik>

        </div>
      </div>
    </div>
  )
}

LoginPage.propTypes = {

}

export default LoginPage
